// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"snackbar__2Uajw","accept":"accept__360jG","button":"button__22-_y","warning":"warning__3b0Hc","cancel":"cancel__2Cpg4","active":"active__3FaiB","label":"label__34qNX"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/snackbar/theme.css
// module id = BVsW
// module chunks = 6